<template>
  <Drawer :drawer="drawer" title="核销记录" :size="1200" @close="handleClose">
    <div class="log-body">
      <BaseTable
        :height="height"
        :tableData="tableData"
        :isPager="false"
        :loading="loading"
      >
        <template slot="index" slot-scope="row">
          {{ tableData.columns.indexOf(row.scope) + 1 }}
        </template>
      </BaseTable>
    </div>
  </Drawer>
</template>
<script>
import { getPaymentVerifyDetails } from '@/api/client'
import { getSupplierPaymentVerifyDetails } from '@/api/supplierPayment'

const BaseTable = () => import('@/components/table/BaseTable.vue')
const Drawer = () => import('@/components/drawer/Drawer')
export default {
  components: { BaseTable, Drawer },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {}
    },
    typeActive: { // 充值水单 0 客户 1 代理
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'invoiceNumber',
            label: '账单号码',
            width: ''
          },
          {
            filed: 'containerNo',
            label: '柜号',
            width: ''
          },
          {
            filed: 'invoiceDateTime',
            label: '账单时间',
            width: ''
          },
          {
            filed: 'invoiceAmount',
            label: '账单金额',
            width: ''
          },
          {
            filed: 'verifedAmount',
            label: '已核销金额',
            width: ''
          },
          {
            filed: 'unVerifedAmount',
            label: '未核销金额',
            width: ''
          }
        ],
        columns: [],
        total: 0
      },
      height: 0
    }
  },
  watch: {
    async drawer(val) {
      if (val) {
        await this.getLists()
        this.$nextTick(() => {
          this.height = document.querySelector('.log-body').offsetHeight - 100
        })
      }
    }
  },
  methods: {
    getLists() {
      this.loading = true
      if (!this.typeActive) {
        getPaymentVerifyDetails({
          paymentId: this.rowData.id
        }).then((res) => {
          if (res.success) {
            this.loading = false
            this.tableData.columns = res.data
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      } else {
        getSupplierPaymentVerifyDetails({
          paymentId: this.rowData.id
        }).then((res) => {
          if (res.success) {
            this.loading = false
            this.tableData.columns = res.data
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      }
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.log-body {
  width: calc(100% - 40px);
  height: 100%;
  margin: 20px auto 20px;
}
</style>
